import styled from 'styled-components'
import { blue as blueColor, green as greenColor, mildGray, orange as orangeColor } from '../../styles/variables.js'

const Button = styled.button`
  border: none;
  padding: 10px 40px;
  outline: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  background: ${blueColor};
  border: 2px solid ${blueColor};
  color: white;
  margin-left: 8px;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }

  ${({ blue, outlined }) => blue ? `
      background: ${ outlined ? 'white' : blueColor };
      border: 2px solid ${blueColor};
      color: ${ outlined ? blueColor: 'white' };
  ` : ''}

  ${({ green, outlined }) => green ? `
    background: ${ outlined ? 'white' : greenColor };
    border: 2px solid ${greenColor};
    color: ${ outlined ? greenColor: 'white' };
  ` : ''}

  ${({ red, outlined }) => red ? `
    background: ${ outlined ? 'white' : 'red' };
    border: 2px solid red;
    color: ${ outlined ? 'red' : 'white' };
  ` : ''}

  ${({ gray, outlined }) => gray ? `
    background: ${ outlined ? 'white' : mildGray };
    border: 2px solid ${mildGray};
    color: ${ outlined ? mildGray: 'white' };
  ` : ''}

  ${({ orange, outlined }) => orange ? `
    background: ${ outlined ? 'white' : orangeColor };
    border: 2px solid ${orangeColor};
    color: ${ outlined ? orangeColor: 'white' };
  ` : ''}

  ${({ disabled }) => disabled ? `
      background: ${mildGray};
      border: 2px solid ${mildGray};
      color: white;
      cursor: not-allowed;
      opacity: 0.7;
      &:hover {
        opacity: 0.7;
      }
  ` : ''}

  &.progress {
    background: url("data:image/svg+xml,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'50'%20height%3D'100'%20viewBox%3D'0%200%205%2010'%3E%0A%09%3Crect%20width%3D'110%25'%20x%3D'-5%25'%20y%3D'-5%25'%20height%3D'110%25'%20fill%3D'%230e74ea'%2F%3E%0A%09%3Cline%20x1%3D'-2'%20y1%3D'1'%20x2%3D'7'%20y2%3D'10'%20stroke%3D'%23157FFB'%20stroke-width%3D'2'%2F%3E%0A%09%3Cline%20x1%3D'-2'%20y1%3D'6'%20x2%3D'7'%20y2%3D'15'%20stroke%3D'%23157FFB'%20stroke-width%3D'2'%2F%3E%0A%09%3Cline%20x1%3D'-2'%20y1%3D'-4'%20x2%3D'7'%20y2%3D'5'%20stroke%3D'%23157FFB'%20stroke-width%3D'2'%2F%3E%0A%3C%2Fsvg%3E");
    animation: progress-indefinite-anim 2s infinite linear 0s;
    @keyframes progress-indefinite-anim {
    	0% {
    		background-position: 0% 0%;
    	}
    	100% {
    		background-position: 100% 0%;
    	}
    }
  }
`

export default {
  Button,
}
